module.exports = __webpack_public_path__ + "static/media/Forklift.a81d47d8.svg";